import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolSidebarService {
  private activeDropdownSubject = new BehaviorSubject<string | null>(null);
  public activeDropdown$ = this.activeDropdownSubject.asObservable();

  constructor() {}

  setActiveDropdown(itemId: string | null) {
    this.activeDropdownSubject.next(itemId);
  }

  getActiveDropdown(): string | null {
    return this.activeDropdownSubject.value;
  }

  closeAllDropdowns() {
    this.activeDropdownSubject.next(null);
  }
}


